import { Add, Clear, Delete, Edit } from '@mui/icons-material';
import { Button, Checkbox, Chip, Divider, Grid, IconButton, InputAdornment, TextField } from '@mui/material';
import { findPersianDefinition } from 'src/utils/findPersianOrder';

const Question = ({ index, title, isActive, onDelete, onEdit, options, answer, onChange }) => {
  const onQuestionChange = (type, value) => {
    const question = {
      title,
      point: 0,
      options,
      answer,
    };
    onChange({
      ...question,
      [type]: value,
    });
  };
  const onDeleteOption = (deletedIndex) => {
    onQuestionChange(
      'options',
      options.filter((_, optionIndex) => optionIndex !== deletedIndex)
    );
  };
  const appendOption = () => {
    onQuestionChange('options', [...options, '']);
  };
  return (
    <Grid container spacing={3} sx={{ my: 'auto' }} alignItems="center">
      <Grid item xs={12}>
        <Chip variant="outlined" color="primary" label={`سوال ${findPersianDefinition(index)}`} />
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          placeholder="سوال"
          fullWidth
          multiline
          value={title}
          onChange={(e) => onQuestionChange('title', e.target.value)}
          disabled={!isActive}
          //   error={qError && question.title === ''}
          InputProps={
            isActive
              ? undefined
              : {
                  endAdornment: (
                    <>
                      <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 3, bgcolor: '#7635dc' }} />
                      <IconButton onClick={() => onDelete(index)}>
                        <Delete />
                      </IconButton>
                      <IconButton onClick={() => onEdit(index)}>
                        <Edit />
                      </IconButton>
                    </>
                  ),
                }
          }
          autoComplete="off"
        />
      </Grid>
      {isActive &&
        options.map((option, optionIndex) => {
          return (
            <Grid item xs={6} key={optionIndex}>
              <TextField
                placeholder={`گزینه ${optionIndex + 1}`}
                fullWidth
                value={option}
                onChange={(e) => {
                  const updatedOptions = [...options];
                  updatedOptions[optionIndex] = e.target.value;
                  onQuestionChange('options', updatedOptions);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {options.length > 2 && (
                        <IconButton onClick={() => onDeleteOption(optionIndex)}>
                          <Clear />
                        </IconButton>
                      )}
                      <Checkbox
                        checked={answer === optionIndex}
                        onChange={(e) => onQuestionChange('answer', optionIndex)}
                      />
                    </InputAdornment>
                  ),
                }}
                autoComplete="off"
              />
            </Grid>
          );
        })}
      {isActive && (
        <Grid item xs={12}>
          <Button onClick={appendOption} endIcon={<Add />}>
            افزودن گزینه
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default Question;
